module.exports = __webpack_public_path__ + "img/logo-outline.200a1729.svg";